import { render, staticRenderFns } from "./InheritanceSourceMenu.vue?vue&type=template&id=79203ba8&scoped=true&"
import script from "./InheritanceSourceMenu.vue?vue&type=script&lang=js&"
export * from "./InheritanceSourceMenu.vue?vue&type=script&lang=js&"
import style0 from "./InheritanceSourceMenu.vue?vue&type=style&index=0&id=79203ba8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79203ba8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer,VDivider,VIcon,VMenu,VSpacer})
